/**
 * DEPRECATED: This file now uses the database-backed service.
 * The hardcoded mappings are kept as fallback for sync operations.
 * Use src/services/products/productVariationService.ts for new code.
 */

import {
  getCanonicalProductName as getCanonicalFromDb,
  getCanonicalProductNames as getCanonicalNamesFromDb,
  getProductVariations as getVariationsFromDb,
  isProductVariation as isVariationFromDb,
} from "@/services/products/productVariationService";

// Legacy hardcoded mapping kept for migration and fallback
const PRODUCT_NAME_MAPPING = {
  "Red Onion A": ["Red Onion A", "Red Onion Grade A", "Red Onion Grade A Restaurant q", "Red Onion Grade A Restaurant quality", "Red Onion ( ሃበሻ )", "Red onion ( ሃበሻ )", "Red Onion (ሃበሻ)", "Red onion (  ሃበሻ  )"],
  "Red Onion B": ["Red Onion B", "Red Onion Grade B"],
  "Red Onion C": ["Red Onion C", "Red Onion Grade C"],
  "Red Onion Elfora": ["Red Onion Elfora", "Red Onion Elfora "],
  "Carrot": ["Carrot", "Carrot B"],
  "Tomato A": ["Tomato A", "Tomatoes Grade A", "Tomato"],
  "Tomato B": ["Tomato B", "Tomatoes B", "Tomatoes Grade B"],
  "Potato": ["Potato", "Potatoes", "Potatoes Chips", "Potatoes Restaurant quality", "Potatoes Restaurant Quality", "Potato Chips"],
  "Chili Green": ["Chili Green", "Chilly Green", "Chilly Green (Starta)", "Chilly Green (Starter)", "Chilly Green Elfora", "Chilly Green (Elfora)"],
  "Beetroot": ["Beetroot", "beetroot", "Beet root"],
  "White Cabbage": ["White Cabbage", "White Cabbage B", "White Cabbage (Large)", "White Cabbage (Small)", "whitecabbage", "White cabbage"],
  "Avocado": ["Avocado", "Avocado A", "Avocado Shekaraw", "Avocado B"],
  "Strawberry": ["Strawberry"],
  "Papaya": ["Papaya", "Papaya B"],
  "Cucumber": ["Cucumber"],
  "Zucchini": ["Zucchini", "Zucchini", "Courgetti", "Courgette"],
  "Garlic": ["Garlic", "Garlic B"],
  "Ginger": ["Ginger"],
  "Pineapple": ["Pineapple", "pineapple", "Pineapple B"],
  "Mango Apple": ["Mango Apple", "Apple Mango"],
  "Lemon": ["Lemon", "lemon", "Lemon", "Lomen"],
  "Orange": ["Orange", "Valencia Orange", "orange Valencia", "Valencia Orange", "Orange Yerer", "Yerer Orange"],
  "Apple": ["Apple"],
  "Corn": ["Corn"],
  "Mango": ["Mango", "Ye Habeshaa Mango", "Ye Habesha Mango"],
  "Green Beans": ["Fossolia", "Green Beans", "Grean Beans"],
  "Salad": ["Salad"],
  "Broccoli": ["Broccoli", "Broccolis"],
  "Sweet Potato": ["Sweet Potatoes", "sweet potato", "Sweet Potato", "sweet potato"],
  "Banana": ["Banana"],
  "Eggplant": ["Egg plant", "eggplant", "Egg plant"],
  "Potato for chips": ["Potato for chips"],
  "Green chili starta": ["Green chili starta", "Green chilli starta"]
};

// Create reverse mapping for quick lookup (legacy sync fallback)
const createReverseMapping = () => {
  const reverseMap: Record<string, string> = {};
  
  Object.entries(PRODUCT_NAME_MAPPING).forEach(([canonical, variations]) => {
    variations.forEach(variation => {
      reverseMap[variation.toLowerCase().trim()] = canonical;
    });
  });
  
  return reverseMap;
};

const REVERSE_MAPPING = createReverseMapping();

/**
 * Get the canonical product name for any variation (sync version - uses fallback)
 * @deprecated Use getCanonicalProductNameAsync for database-backed lookup
 */
export function getCanonicalProductName(productName: string): string {
  if (!productName) return productName;
  
  const normalized = productName.toLowerCase().trim();
  return REVERSE_MAPPING[normalized] || productName;
}

/**
 * Get the canonical product name from database (async)
 */
export async function getCanonicalProductNameAsync(productName: string): Promise<string> {
  return getCanonicalFromDb(productName);
}

/**
 * Get all variations for a canonical product name (sync version - uses fallback)
 * @deprecated Use getProductVariationsAsync for database-backed lookup
 */
export function getProductVariations(canonicalName: string): string[] {
  return PRODUCT_NAME_MAPPING[canonicalName as keyof typeof PRODUCT_NAME_MAPPING] || [canonicalName];
}

/**
 * Get all variations from database (async)
 */
export async function getProductVariationsAsync(canonicalName: string): Promise<string[]> {
  return getVariationsFromDb(canonicalName);
}

/**
 * Get all canonical product names (sync version - uses fallback)
 * @deprecated Use getCanonicalProductNamesAsync for database-backed lookup
 */
export function getCanonicalProductNames(): string[] {
  return Object.keys(PRODUCT_NAME_MAPPING);
}

/**
 * Get all canonical product names from database (async)
 */
export async function getCanonicalProductNamesAsync(): Promise<string[]> {
  return getCanonicalNamesFromDb();
}

/**
 * Check if a product name matches any variation of a canonical name (sync version)
 * @deprecated Use isProductVariationAsync for database-backed lookup
 */
export function isProductVariation(productName: string, canonicalName: string): boolean {
  const variations = getProductVariations(canonicalName);
  return variations.some(variation => 
    variation.toLowerCase().trim() === productName.toLowerCase().trim()
  );
}

/**
 * Check if a product name matches any variation (async)
 */
export async function isProductVariationAsync(productName: string, canonicalName: string): Promise<boolean> {
  return isVariationFromDb(productName, canonicalName);
}

/**
 * Get the legacy mapping for migration purposes
 */
export function getLegacyProductMapping(): Record<string, string[]> {
  return { ...PRODUCT_NAME_MAPPING };
}